import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MatDialogModule } from '@angular/material/dialog';
import { materialModules } from '../../../angular-material.module';
import { SharedModule } from '../../../shared/shared.module';
import { QuillModule } from 'ngx-quill'
import { CreativeUnitPackageListingContainerComponent } from './creative-unit-package-listing-container/creative-unit-package-listing-container.component';
import { CreativeUnitPackageListingListComponent } from './creative-unit-package-listing-list/creative-unit-package-listing-list.component';
import { CreativeUnitPackageListingCardComponent } from './creative-unit-package-listing-card/creative-unit-package-listing-card.component';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { getPaginatorIntl } from '../../services/localization.service';
import { CreativeUnitPackageListingChildrenDialogComponent } from './creative-unit-package-listing-children-dialog/creative-unit-package-listing-children-dialog.component';
import { CartListModule } from '../cart/cart-list/cart-list.module';
import { TippyDirective } from '@ngneat/helipopper';


@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		RouterModule,
		MatDialogModule,
		ReactiveFormsModule,
		SharedModule,
		...materialModules,
		QuillModule.forRoot(),
		CartListModule,
		TippyDirective
	],
	declarations: [
		CreativeUnitPackageListingContainerComponent,
		CreativeUnitPackageListingListComponent,
		CreativeUnitPackageListingCardComponent,
		CreativeUnitPackageListingCardComponent,
		CreativeUnitPackageListingChildrenDialogComponent
	],
	exports: [
		CreativeUnitPackageListingContainerComponent,
		CreativeUnitPackageListingListComponent,
		CreativeUnitPackageListingCardComponent,
		CreativeUnitPackageListingChildrenDialogComponent
	],
	providers: [
		{ provide: MatPaginatorIntl, useFactory: getPaginatorIntl }
	],
})
export class CreativeUnitPackageListingModule {}
